import { createFileRoute, Link } from "@tanstack/react-router";
import { EMAIL } from "@/lib/contacto";

export const Route = createFileRoute("/terminos")({
  component: Terminos,
  head: () => ({
    meta: [
      { title: "Términos y condiciones | Pyme Visible" },
      {
        name: "description",
        content:
          "Condiciones de uso del sitio de Pyme Visible: información de servicios, solicitud de contacto y alcance que se confirma por escrito antes de contratar.",
      },
      { property: "og:title", content: "Términos y condiciones | Pyme Visible" },
      {
        property: "og:description",
        content: "Uso del sitio, contenidos, enlaces de terceros y disponibilidad.",
      },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_CL" },
      { property: "og:url", content: "https://pymevisible.cl/terminos" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Términos y condiciones | Pyme Visible" },
      {
        name: "twitter:description",
        content: "Condiciones de uso del sitio de Pyme Visible.",
      },
    ],
    links: [{ rel: "canonical", href: "https://pymevisible.cl/terminos" }],
  }),
});

function Terminos() {
  return (
    <main id="contenido" lang="es-CL" className="pv-legal-page mx-auto max-w-3xl px-5 py-20">
      <Link to="/" className="text-sm font-medium text-primary underline">
        ← Volver al inicio
      </Link>
      <h1 className="mt-6 text-3xl font-extrabold text-navy sm:text-4xl">Términos y condiciones</h1>

      <div className="pv-legal-copy mt-8 grid gap-8 leading-relaxed text-muted-foreground">
        <p>Esta información es general y no reemplaza una asesoría legal.</p>

        <section>
          <h2 className="text-xl font-bold text-navy">Qué es este sitio</h2>
          <p className="mt-3">
            Este sitio informa sobre los servicios de Pyme Visible y permite solicitar contacto. No
            se realizan pagos ni se celebran contratos dentro de la web.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-navy">Precios e información de servicios</h2>
          <p className="mt-3">
            Los precios y descripciones publicados son referenciales y sirven para orientarte. El
            alcance definitivo, el precio final, los plazos, la eventual entrega o despacho, la
            forma de pago, la cancelación y cualquier otra condición aplicable se confirman por
            escrito con cada cliente antes de contratar.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-navy">Uso permitido</h2>
          <p className="mt-3">
            Puedes navegar el sitio y usar sus contenidos para informarte y contactarnos. No está
            permitido usarlo para actividades ilícitas, intentar vulnerar su funcionamiento ni
            enviar información falsa o de terceros sin autorización.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-navy">Contenidos y propiedad intelectual</h2>
          <p className="mt-3">
            Los contenidos propios de este sitio están protegidos según corresponda. Las marcas,
            nombres y capturas de terceros pertenecen a sus respectivos titulares y se muestran solo
            con fines ilustrativos.
          </p>
          <p className="mt-3">
            Las fotografías, capturas y materiales visuales publicados en este sitio son de
            titularidad del responsable, fueron creados con herramientas de inteligencia artificial
            o provienen de bancos de imágenes con licencia de uso compatible. Las reseñas publicadas
            corresponden a experiencias reales de clientes. No se publicarán datos personales
            identificables sin la autorización correspondiente.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-navy">Enlaces y servicios de terceros</h2>
          <p className="mt-3">
            El sitio puede enlazar o, con tu autorización, incorporar servicios de terceros como
            Google Maps, Google Analytics, WhatsApp o redes sociales. No controlamos esos servicios
            ni sus políticas.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-navy">Disponibilidad</h2>
          <p className="mt-3">
            Procuramos mantener el sitio disponible y su información actualizada, pero puede haber
            interrupciones por mantenimiento o causas ajenas a nosotros. Esto no afecta los derechos
            que la ley reconoce a los consumidores.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-navy">Responsable y legislación</h2>
          <p className="mt-3">
            Este sitio es operado por Álvaro Silva González. Estos términos se rigen por las leyes
            de la República de Chile. Cualquier controversia será conocida por los tribunales
            competentes de Chile, sin perjuicio de los derechos irrenunciables que correspondan a
            las personas consumidoras conforme a la legislación aplicable.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-navy">Contacto</h2>
          <p className="mt-3">
            Para consultas sobre estos términos escríbenos a{" "}
            <a className="font-medium text-primary underline" href={`mailto:${EMAIL}`}>
              {EMAIL}
            </a>
            .
          </p>
        </section>
      </div>
    </main>
  );
}
